module.exports = __webpack_public_path__ + "media/4.1cb5230d.mp3";